import { useState } from 'react';
import classNames from 'classnames';
import { useCustomerContext } from '@/lib/customer/CustomerContext';
import { isPurchaseFlowEnabled } from '@/lib/purchase-flow';
import { isTradeInAvailable } from '@/lib/trade-in';
import { priceFormater } from '@/settings';
import i18n from '@/settings/i18n';
import TradeInModal, { type TradeInViewT } from './TradeInModal';
import useTradeInQuote from './useTradeInQuote';

const t = i18n.init('buyback');

/**
 * The trade-in beside the purchase flow's sticky total: "Add a trade-in" until
 * there's one, then their combined value, which opens every trade-in as Edit
 * does on the PDP.
 */
const TradeInBarLink = ({ className }: { className?: string }) => {
  const { customer } = useCustomerContext();
  const { quotes, remove } = useTradeInQuote();
  const [view, setView] = useState<TradeInViewT | null>(null);

  if (!isTradeInAvailable() || !isPurchaseFlowEnabled(customer?.email)) {
    return null;
  }

  const value = quotes.reduce((sum, quote) => sum + quote.value, 0);

  return (
    <>
      <button
        type="button"
        onClick={() => setView(quotes.length > 0 ? 'offer' : 'widget')}
        className={classNames(
          'text-sm underline underline-offset-2',
          quotes.length > 0
            ? 'font-medium text-[#128452] hover:text-[#128452]/80'
            : 'hover:text-gray-700/80',
          className,
        )}
      >
        {quotes.length > 0 ? (
          <>
            {t`Trade-in`}{' '}
            <span translate="no">
              {priceFormater.short(value, !Number.isInteger(value))}
            </span>
          </>
        ) : (
          t`Add a trade-in`
        )}
      </button>
      <TradeInModal
        view={view}
        setView={setView}
        quotes={quotes}
        onRemove={remove}
      />
    </>
  );
};

export default TradeInBarLink;
